"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var utils_1 = require("@material-ui/core/utils");
exports.default = utils_1.createSvgIcon(React.createElement("path", { d: "M6.317 4.742a1.832 1.832 0 00-2.712-.259c-.706.653-.762 1.756-.19 2.532l3.687 4.962-3.71 5.008c-.572.777-.527 1.88.19 2.532a1.832 1.832 0 002.713-.259l5.178-6.988a.491.491 0 000-.574L6.317 4.742zM17.683 4.742a1.832 1.832 0 012.712-.259c.706.653.762 1.756.19 2.532l-3.687 4.962 3.71 5.008c.571.777.526 1.88-.19 2.532a1.832 1.832 0 01-2.713-.259l-5.167-7a.492.492 0 010-.573l5.145-6.943z" }), "Mixer");
//# sourceMappingURL=Mixer.js.map